var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"relative","width":"100%","height":"100%"}},[_c('canvas',{attrs:{"id":_vm.canvasId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }